<template>
  <vx-card no-shadow>
    <vs-input class="w-full mb-base" label-placeholder="Old Password" v-model="old_password" />
    <vs-input
      type="password"
      v-validate="'required|min:6'"
      ref="password"
      placeholder="New Password"
      name="password"
      v-model="new_password"
      class="mt-5 w-full"
    />
    <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
    <vs-input
      type="password"
      v-validate="'required|min:6|confirmed:password'"
      data-vv-as="password"
      placeholder="Confirm Password"
      name="confirm_password"
      v-model="confirm_new_password"
      class="mt-5 w-full"
    />
    <span class="text-danger text-sm" v-show="errors.has('confirm_password')">{{ errors.first('confirm_password') }}</span>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="submit">Save Changes</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
    </div>
  </vx-card>
</template>

<script>
import firebase from 'firebase'
import 'firebase/auth'
export default {
  data() {
    return {
      old_password: '',
      new_password: '',
      confirm_new_password: '',
    }
  },
  methods: {
    submit() {
      this.$vs.loading({
        type: 'corners',
      })
      this.reauthenticate(this.old_password)
        .then(() => {
          const user = firebase.auth().currentUser
          user
            .updatePassword(this.new_password)
            .then(() => {
              this.$vs.loading.close()
              this.$vs.notify({
                color: 'success',
                title: 'Password',
                text: 'Password changes successfully',
              })
            })
            .catch((error) => {
              this.$vs.loading.close()
              this.$vs.notify({
                color: 'warning',
                title: 'Error occurred',
                text: error,
              })
            })
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            color: 'warning',
            title: 'Error occurred',
            text: error,
          })
        })
    },
    reauthenticate() {
      const user = firebase.auth().currentUser
      const cred = firebase.auth.EmailAuthProvider.credential(user.email, this.old_password)
      return user.reauthenticateWithCredential(cred)
    },
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
}
</script>
